import SelectBox, {
  Item,
  MultiSelectProps,
  OtherSelectBoxProps,
  SingleSelectProps,
} from '@/components/select/SelectBox';

import { formatOrderPredictionAlgorithm, OrderPredictionAlgorithm } from '@/models/OrderPrediction';

export interface AlgorithmItem {
  id: OrderPredictionAlgorithm;
  name: string;
}

type AlgorithmSelectBoxProps<T extends Item> =
  | (SingleSelectProps<T> &
      OtherSelectBoxProps<T> & {
        multiple?: false;
        algorithms?: OrderPredictionAlgorithm[];
      })
  | (MultiSelectProps<T> &
      OtherSelectBoxProps<T> & {
        multiple: true;
        algorithms?: OrderPredictionAlgorithm[];
      });

const defaultAlgorithms: OrderPredictionAlgorithm[] = ['simple_reorder'];

const OrderPredictionAlgorithmSelectBox = (props: AlgorithmSelectBoxProps<AlgorithmItem>) => {
  const {
    label = 'Algorithm:',
    placeholder = 'Select algorithm',
    algorithms = defaultAlgorithms,
  } = props;

  const listAlgorithms = (): Promise<AlgorithmItem[]> => {
    return new Promise((resolve) => {
      const items: AlgorithmItem[] = algorithms.map((a) => ({
        id: a,
        name: formatOrderPredictionAlgorithm(a),
      }));

      resolve(items);
    });
  };

  return (
    <SelectBox<AlgorithmItem>
      {...props}
      name="algorithm"
      label={label}
      placeholder={placeholder}
      queryFn={listAlgorithms}
      itemRender={(item: AlgorithmItem, selected?: boolean) => (
        <span className={`${selected ? 'font-semibold' : 'font-normal'} block truncate`}>
          {item.name}
        </span>
      )}
    />
  );
};

export default OrderPredictionAlgorithmSelectBox;
